import React from 'react';
import { HashLink } from 'react-router-hash-link';

import Share from './Share';


export default () => (
  <div id="Screen_3">
    <div class="gp-content1">
      <h2 class="gp-title">
        JE ME DÉCLARE #TÉMOINDUCLIMAT SUR LES RÉSEAUX SOCIAUX
      </h2>
      <p>
        Pour que l’État ne puisse plus ignorer la réalité de l’urgence climatique
        et agisse à la hauteur de ce défi, faites entendre votre voix avec l’Affaire du Siècle !
        Déclarez-vous #TémoinDuClimat sur votre réseau social préféré :
      </p>
      <div class="gp-mess-partage">
        <p class="titre-partage">
          Partagez sur les réseaux sociaux
        </p>
        <div class="gp-text-partage">
          <span>&quot; Canicules, inondations, érosion des côtes…</span>
          <br/>
          <span>Les changements climatiques se font déjà sentir en France !</span>
          <br/>
          <span>L'État doit prendre la mesure de l'urgence climatique et agir. </span>
          <br/>
          <span>Je suis #TémoinDuClimat avec #LAffaireDuSiecle, et vous ? &quot;</span>
        </div>
        <Share/>
      </div>
    </div>
  </div>
);
